import makeStyles from '@material-ui/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import IconContentCopyOutline from 'assets/Icons/IconContentCopyOutline';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { copyToClipboard } from 'helpers/helpers';
import { type SVGProps, useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

type CopyToClipboardProps = {
  text: string;
  IconProps?: SVGProps<SVGSVGElement>;
  classes?: { root?: string };
};

const useStyles = makeStyles({
  root: {
    color: grayColor[6],
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    padding: 0,
    lineHeight: 0,
  },
});

const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { text, IconProps, classes: classesProp } = props;
  const { t } = useTranslation();

  const classes = useStyles();

  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  return (
    <Tooltip
      title={isCopied ? t('copyToClipboard.copied') : t('copyToClipboard.copy')}
      disableFocusListener={true}
      placement="top"
    >
      <button
        className={classNames(classes.root, classesProp?.root)}
        onClick={() => {
          copyToClipboard(text, () => setIsCopied(true));
        }}
        onMouseLeave={() => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            setIsCopied(false);
          }, 150);
        }}
      >
        <IconContentCopyOutline width={20} height={20} {...IconProps} />
      </button>
    </Tooltip>
  );
};

export default CopyToClipboard;
